import React from 'react';
import TenantGuard from '@components/common/TenantGuard';
import VisaAnalyticsContainer from '../containers/visa-application-analytics.container';

export const visaAnalyticsRoutes = [
  {
    path: 'analytics',
    element: (
      <TenantGuard
        showHeader={true}
        headerTitle="Visa Application Analytics"
        showBreadcrumbs={true}
      >
        <VisaAnalyticsContainer />
      </TenantGuard>
    ),
  },
];

export default visaAnalyticsRoutes;
